import { createSlice } from '@reduxjs/toolkit';
import Cookies from 'js-cookie';
import { HYDRATE } from 'next-redux-wrapper';
import Router from 'next/router';

import pageUrls from 'constants/pagesUrls';

import type { HydrateAction } from 'redux-store/index';
import authorizationThunk from 'redux-store/thunks/profile/authorizationThunk';
import getProfileThunk from 'redux-store/thunks/profile/getProfileThunk';
import getSocialProvidersThunk from 'redux-store/thunks/profile/getSocialProvidersThunk';
import logoutThunk from 'redux-store/thunks/profile/logoutThunk';
import registrationThunk from 'redux-store/thunks/profile/registrationThunk';
import resetPasswordThunk from 'redux-store/thunks/profile/resetPasswordThunk';

import type { ProfileStateType } from './types';

const initialState = {
  isAuthenticated: false,
  error: '',
  detail: '',
  profile: {},
  providers: null,
} as ProfileStateType;
const ProfileSlice = createSlice({
  name: 'profile',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder.addCase(getProfileThunk.fulfilled, (state, action) => {
      if (action.payload.success === true) {
        state.isAuthenticated = true;
        state.profile = action.payload;
      } else {
        state.isAuthenticated = false;

        let message = '';
        if (typeof action.payload.error === 'string') {
          message = action.payload.error;
        } else {
          const values = Object.values(
            action.payload.error as unknown as {
              [key: string]: string;
            }[],
          );
          const { 0: error } = values as unknown as string[];
          const [text] = error || [''];
          message = text;
        }

        state.error = message;
      }
    });

    builder.addCase(authorizationThunk.fulfilled, (state, action) => {
      if (action.payload.success) {
        const next = Router.router?.query.next;

        if (typeof next === 'string') {
          const redirectUrl = global.location.origin + next;

          Cookies.set('next-auth-redirect-url', redirectUrl);
        }

        if (global.location.href?.endsWith('/plans/')) {
          Router.reload();

          return;
        }

        Router.replace(pageUrls.authCallback);
      }
      else {
        state.isAuthenticated = false;
        let message = '';
        if (typeof action.payload.error === 'string') {
          message = action.payload.error;
        } else {
          const values = Object.values(
            action.payload.error as unknown as {
              [key: string]: string;
            }[],
          );
          const { 0: error } = values as unknown as string[];
          const [text] = error || [''];
          message = text;
        }

        state.error = message;
        state.detail = action.payload.details ?? '';
      }
    });

    builder.addCase(resetPasswordThunk.fulfilled, (state, action) => {
      if (action.payload.success === true) {
        state.error = '';
      } else {
        state.error = action.payload.error ?? '';
      }
    });

    builder.addCase(registrationThunk.rejected, (state, action) => {
      state.error = action.error.message ?? '';
    });

    builder.addCase(getSocialProvidersThunk.fulfilled, (state, action) => {
      state.providers = action.payload;
    });

    builder.addCase(logoutThunk.fulfilled, () => {
      Router.reload();
    });

    builder.addCase(
      HYDRATE,
      (state, action: HydrateAction<ProfileStateType>) => {
        return action.payload.profile;
      },
    );
  },
});

export default ProfileSlice.reducer;
